export default __webpack_public_path__ + "static/media/pdf_placeholder.afe8d0b5.png";